// extracted by mini-css-extract-plugin
export default {"section-9":"styles_section-9__3LFsJ","blog-article":"styles_blog-article__fhxrr","image":"styles_image__t1gqt","content":"styles_content__2rQMD"};